import { render } from "./LoginHistoryView.vue?vue&type=template&id=4bb1ced2"
import script from "./LoginHistoryView.vue?vue&type=script&lang=js"
export * from "./LoginHistoryView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__